import { StrictMode, useContext, useEffect } from "react";
import { createRoot } from "react-dom/client";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { LanguageContext } from "./contexts/LanguageContext";
import Rotate from "./components/Rotate/Rotate.jsx";
import { LanguageProvider } from "./contexts/LanguageContext";
import BottomPanel from "./components/BottomPanel/BottomPanel.jsx";
import LanguageSelector from "./components/LanguageSelector/LanguageSelector.jsx";
import ClickToBuy from "./components/ClickToBuy/ClickToBuy.jsx";

function PaymentApp() {
  const { language, updateLanguage } = useContext(LanguageContext);

  useEffect(() => {
    updateLanguage(null);
  }, []);

  return (
    <Router>
      <Rotate />
      <Routes>
        <Route
          path="/"
          element={
            <BottomPanel>
              {!language ? <LanguageSelector /> : <ClickToBuy />}
            </BottomPanel>
          }
        />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export async function bootstrapPaymentApp() {
  createRoot(document.getElementById("root")).render(
    <StrictMode>
      <LanguageProvider>
        <PaymentApp />
      </LanguageProvider>
    </StrictMode>
  );
}
